import { render } from "./verify_email.vue?vue&type=template&id=a57548dc&scoped=true&ts=true"
import script from "./verify_email.vue?vue&type=script&lang=ts"
export * from "./verify_email.vue?vue&type=script&lang=ts"

import "@/style/common.less?vue&type=style&index=0&id=a57548dc&scoped=true&lang=less&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57548dc"]])

export default __exports__